import IconButton from '@material-ui/core/IconButton'
import { createStyles, withStyles } from '@material-ui/core/styles'
import RemoveCircle from '@material-ui/icons/RemoveCircle'
import PropTypes from 'prop-types'
import { translate } from 'ra-core'
import React, { useEffect } from 'react'
import compose from 'recompose/compose'
import { getApiUrl } from '../auth/client'

const styles = (theme) =>
  createStyles({
    removeButton: { position: 'absolute', right: 0, padding: 5 },
    removeIcon: {
      color: theme.palette.accent1Color,
    },
  })

export const FileInputPreview = (props) => {
  const { classes = {}, className, onRemove, file, translate, ...rest } = props

  const [apiUrl, setApiUrl] = React.useState('')
  useEffect(() => {
    const fetchApiUrl = async () => {
      const url = await getApiUrl()
      setApiUrl(url)
    }
    fetchApiUrl()
  }, [])

  return (
    <div className={className} {...rest}>
      <IconButton className={classes.removeButton} onClick={onRemove} title={translate('ra.action.delete')}>
        <RemoveCircle className={classes.removeIcon} />
      </IconButton>
      <a href={`${apiUrl}/api/files/${file}`} target="_blank" rel="noreferrer noopener">
        <img
          src={`${apiUrl}/api/files/${file}`}
          title="logo"
          style={{ width: '100%', objectFit: 'contain', maxHeight: '250px' }}
          alt="logo"
        />
      </a>
    </div>
  )
}

FileInputPreview.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  file: PropTypes.object,
  onRemove: PropTypes.func.isRequired,
}

FileInputPreview.defaultProps = {
  file: undefined,
  translate: (id) => id,
}

export default compose(withStyles(styles), translate)(FileInputPreview)
